<template>
    <div class="elle-headline-content">
        <div class="container">
            <div v-show="settings?.label" class="page-label w-space">{{ settings?.label }}</div>
            <div class="grid12">
                <div class="l-col">
                    <h3 v-show="settings?.headline" class="page-headline" v-html="nl2br(settings?.headline)" />
                    <slot name="additional" />
                </div>
                <div class="r-col">
                    <slot name="content">
                        <div class="content" v-html="settings?.content" />
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});
</script>
